import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  error: Error | null;
}

/** Zamiast białego ekranu: komunikat i przycisk odświeżenia. Dane lokalne zostają nietknięte. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Błąd interfejsu', error, info.componentStack);
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center gap-4 p-6 text-center">
        <h1 className="text-xl font-semibold">Coś poszło nie tak</h1>
        <p className="text-stone-600 dark:text-stone-400">Twoje listy są bezpieczne w telefonie. Spróbuj odświeżyć.</p>
        <pre className="overflow-x-auto rounded bg-stone-100 p-2 text-left text-xs text-stone-500 dark:bg-stone-900">
          {this.state.error.message}
        </pre>
        <button onClick={() => location.reload()} className="rounded-xl bg-brand-700 py-3 font-medium text-white">
          Odśwież
        </button>
      </main>
    );
  }
}
